import type { Page as PageType } from 'src/types/page';
import { ServicePage } from 'src/sections/services/service-page';

const Page: PageType = () => (
  <ServicePage
    seoTitle="Marketing & Paid Media | Mystic Media Film"
    seoDescription="Full-funnel marketing from Mystic Media Film. Strategy, paid media, SEO, and creative for Houston brands ready to compound their growth month over month."
    service="Marketing"
    eyebrow="Marketing — 2026"
    headline="Marketing that"
    accent="moves metrics."
    sub="Campaigns, funnels, and growth plays built on data — not vibes."
    description="Full-funnel marketing, end to end. |Strategy, creative, launch, and measurement — all under one roof."
    deliverables={[
      { num: '01', title: 'Strategy', body: 'Positioning, ICP work, and a quarterly roadmap your team can execute.' },
      { num: '02', title: 'Campaigns', body: 'Integrated launches across paid, organic, email, and on-site.' },
      { num: '03', title: 'Email & CRM', body: 'Sequences, flows, and nurture tracks that move leads to revenue.' },
      { num: '04', title: 'Creative', body: 'Ad creative, landing pages, and assets produced in-house.' },
      { num: '05', title: 'Analytics', body: 'Dashboards, attribution, and weekly readouts on what actually worked.' },
      { num: '06', title: 'Iteration', body: 'Test, learn, and scale — monthly cadence, zero fluff.' }
    ]}
    outcomes={['Pipeline', 'Leads', 'Revenue', 'Clarity']}
    process={[
      { num: '01', title: 'Strategy', body: 'Audit, ICP work, positioning, and a quarterly roadmap your team can execute.' },
      { num: '02', title: 'Build', body: 'Creative, landing pages, automations, and tracking — wired up before anything goes live.' },
      { num: '03', title: 'Launch', body: 'Multi-channel campaigns rolled out with proper attribution and a learning agenda.' },
      { num: '04', title: 'Iterate', body: 'Weekly readouts, structured tests, and steady scaling on what actually moves the needle.' }
    ]}
    whyUs={[
      { title: 'Built on data, not vibes', body: 'Every decision ties back to a measurable outcome. Dashboards, attribution, and weekly readouts make the wins (and the misses) impossible to miss.' },
      { title: 'Creative + media in one team', body: 'No more blaming creative for bad ads or media buying for soft creative. We own the full loop — strategy through execution.' },
      { title: 'Transparent reporting', body: 'You see the numbers we see. Spend, ROAS, attribution, and learnings — every week, in plain English.' }
    ]}
    faqs={[
      { q: "What's the minimum engagement?", a: 'We work in 90-day blocks for marketing engagements. That gives campaigns time to compound and tests time to produce real signal.' },
      { q: 'Do you manage ad spend?', a: 'Yes — Meta, Google, TikTok, LinkedIn, and YouTube. Spend stays in your accounts, in your name, with full visibility.' },
      { q: 'How fast will I see results?', a: 'Pipeline metrics move in weeks, revenue typically lands in the 60–90 day window. We share a forecast up front and update it weekly.' },
      { q: 'Do I own the assets?', a: 'Always. Accounts, creative, copy, and data live in your name from day one — no agency lock-in.' },
      { q: "What's your reporting cadence?", a: 'Weekly readouts on what changed and why, plus a monthly strategy review. No 40-page decks — just the numbers and the next move.' },
      { q: 'Can you work with our existing team?', a: 'Yes. We plug into in-house teams as a creative or media partner, or run the whole stack — whichever fits your structure.' }
    ]}
  />
);

export default Page;
